import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '../common/Button';
import tableConfig, { data } from './config';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { useHistory } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import FormValidator from '../../utils/validator';
import { toast } from 'react-toastify';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { TimePicker } from 'antd';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getsellerslist, getcategorieslist, getcuisineslist, gettagslist, getzipcodeslist, getmetricslist, addsellerdish } from '../../actions/fooditems';
import * as Icons from '../Icons';
import { AWS_ACCESS_KEY, AWS_SECRET_KEY, BUCKET_NAME, S3URL, REGION_NAME } from '../../constants';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import S3 from 'react-aws-s3';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const GreenCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#43a047',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);



const AddItems = (props) => {
  var fileObj = [];
  var fileArray = [];
  var tagsinput = [];
  var ImageNames = [];
  const classes = props.classes;
  const history = useHistory();
  let session = sessionStorage.getItem('user');
  let countryid = session ? `${JSON.parse(session).countryId}` : "";
  const [isLoading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [cityId, setCityId] = useState(0);
  const [categorieslist, setCategorieslist] = useState([]);
  const [sellerslist, setSellersList] = useState([]);
  const [cuisineslist, setCuisinesList] = useState([]);
  const [tagslist, setTagsList] = useState([]);
  const [zipcodeslist, setZipcodesList] = useState([]);
  const [tagin, setTagIn] = useState([]);
  const [metricslist, setMetricsList] = useState([]);
  const [sellertype, setSellerType] = useState("chefs");
  const [pinError, setPinError] = useState(false);
  const [ftimeError, setFtimeError] = useState(false);
  const [ttimeError, setTtimeError] = useState(false);
  const [activeChef, setActiveChef] = useState(true);
  const [activeRes, setActiveRes] = useState(false);
  const [activeVeg, setActiveVeg] = useState(true);
  const [activeNonVeg, setActiveNonVeg] = useState(false);
  const [dishtype, setDishType] = useState("Veg");
  const [file, setFile] = useState("");
  //const [metric, setMetric] = useState("");
  //const [qty, setDishQty] = useState("");
  const [inputList, setInputList] = useState([{ fromTime: null, toTime: null }]);
  const [zipName, setZipName] = useState([]);
  //console.log("zipName",zipName);
  const config = {
    region: REGION_NAME,
    bucketName: BUCKET_NAME,
    accessKeyId: AWS_ACCESS_KEY,
    secretAccessKey: AWS_SECRET_KEY,
    s3Url: S3URL
  };
  useEffect(() => {
    getcategorieslist(countryid).then((response) => {
      setCategorieslist(response.data.details.categories === null ? '' : response.data.details.categories);
    });
  }, []);
  useEffect(() => {
    getsellerslist(countryid, sellertype).then((response) => {
      if (sellertype != "" || sellertype != null) {
        setSellersList(response.data.details.sellers === null ? '' : response.data.details.sellers);
      }
    })
  }, [sellertype]);

  useEffect(() => {
    getcuisineslist().then((response) => {
      setCuisinesList(response.data.details.cuisines === null ? '' : response.data.details.cuisines);
    })
  }, []);

  useEffect(() => {
    gettagslist().then((response) => {
      setTagsList(response.data.details.tags === null ? '' : response.data.details.tags);
    })
  }, []);

  useEffect(() => {
    getzipcodeslist(cityId).then((response) => {
      setZipcodesList(response.data.details.pinCodes === null ? '' : response.data.details.pinCodes);
    })
  }, [cityId]);

  useEffect(() => {
    getmetricslist().then((response) => {
      setMetricsList(response.data.details.metrics === null ? '' : response.data.details.metrics);

    })
  }, []);
  const SellerdefaultProps = {
    options: sellerslist,
    getOptionLabel: (option) => option.businessName,
    getOptionValue: (option) => option.sellerId,

  };

  const CatedefaultProps = {
    options: categorieslist,
    getOptionLabel: (option) => option.categoryName,
  };

  const CuidefaultProps = {
    options: cuisineslist,
    getOptionLabel: (option) => option.cuisineName,
  };

  const MetricfaultProps = {
    options: metricslist,
    getOptionLabel: (option) => option.metric,
  };

  const CateflatProps = {
    options: categorieslist.map((option) => option.categoryName),
  };

  const SellerflatProps = {
    options: sellerslist.map((option) => option.businessName),
  };
  const CuiflatProps = {
    options: cuisineslist.map((option) => option.cuisineName),
  };

  const MetricflatProps = {
    options: metricslist.map((option) => option.metric),
  };

  const handleSellerType = (e) => {
    const { name, value } = e.target;
    if (value == "chefs") {
      setActiveChef(true);
      setActiveRes(false);
      setSellerType(value);
    }
    if (value == "restaurants") {
      setActiveChef(false);
      setActiveRes(true);
      setSellerType(value);
    }

  };
  const handleDishType = (e) => {
    const { name, value } = e.target;
    if (value == "Veg") {
      setActiveVeg(true);
      setActiveNonVeg(false);
      setDishType(value);
    }
    if (value == "Non Veg") {
      setActiveVeg(false);
      setActiveNonVeg(true);
      setDishType(value);
    }
  };

  const handleChangeTag = (e, id) => {
    const list = [...tagin]
    if (e.target.checked == true) {
      tagin.push(id);
    }
    if (e.target.checked == false) {
      let indexId = tagin.indexOf(id);
      tagin.splice(indexId, 1);
    }
    setTagIn(tagin);
  }
  // handle input change
  const onChange = (time, timeString, index, Inname) => {
    const list = [...inputList];
    inputList[index][Inname] = timeString
  };

  // handle click event of the Remove button
  const handleRemoveClick = index => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  // handle click event of the Add button
  const handleAddClick = () => {
    setInputList([...inputList, { fromTime: null, toTime: null }]);
  };

  const uploadMultipleFiles = (e) => {
    const newArray = [...file];
    fileObj.push(e.target.files);
    for (let i = 0; i < fileObj[0].length; i++) {
      let imageUrl = fileObj[0][i];
      let newfileName = fileObj[0][i].name;
      const ReactS3Client = new S3(config);
      ReactS3Client.uploadFile(imageUrl, newfileName).then(data => {
        newArray.push(data.location);
        setFile([...file, newArray]);
      });
      //fileArray.push(URL.createObjectURL(fileObj[0][i]));
    }
  };
  const removeImage = (url) => {
    const newImageArray = [...file];
    let indexUrl = file.indexOf(url);
    newImageArray.splice(indexUrl, 1);
    setFile(newImageArray)
  };

  const handleChangeSeller = (key, e) => {
    setCityId(e.cityId);
    setDish({
      ...dish,
      [key]: e.sellerId
    })
  }

  const handleChangeZipcode = (event) => {
    const {
      target: { value },
    } = event;
    setZipName(
      typeof value === 'string' ? value.split(',') : value,
    );

  }

  const handleChangeCui = (key, e) => {
    setDish({
      ...dish,
      [key]: e.cuisineId
    })
  }
  const handleChangeMetric = (key, e) => {
    setDish({
      ...dish,
      [key]: e.metric
    })
  }

  const handleChangeCate = (key, e) => {
    setDish({
      ...dish,
      [key]: e.categoryId
    })
  }
  const handleChange = (key, e) => {
    setDish({
      ...dish,
      [key]: e.target.value
    })

  }

  const [dish, setDish] = useState({
    sellerId: "",
    itemName: "",
    description: "",
    weight: "",
    metric: "",
    price: "",
    maxDishesPerDay: "",
    cuisineId: "",
    categoryId: ""
  })
  const schemadish = [
    {
      field: 'sellerId',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Select Seller.',
    },
    {
      field: 'itemName',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Enter Dish Name.',
    },
    {
      field: 'description',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Enter Dish Decription.',
    },

    {
      field: 'price',
      method: ['matches'],
      args: [/([1-9][0-9]*)|0/],
      validWhen: true,
      message: 'Enter dish price it should be numeric',
    },
    {
      field: 'maxDishesPerDay',
      method: ['matches'],
      args: [/([1-9][0-9]*)|0/],
      validWhen: true,
      message: 'Enter no.of dishes it should be numeric',
    },
    {
      field: 'cuisineId',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Select Dish Cuisine.',
    },
    {
      field: 'categoryId',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Select Dish Category.',
    },
    {
      field: 'weight',
      method: ['matches'],
      args: [/([1-9][0-9]*)|0/],
      validWhen: true,
      message: 'Enter dish quantity and it should be numeric',
    },

    {
      field: 'metric',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Select Metric',
    },

  ];

  const validatordish = new FormValidator(schemadish);
  const addDish = () => {
    var newdishtimes = [];
    if (zipName.length == 0) {
      setPinError(true);
    } else {
      setPinError(false);
    }


    const err = validatordish.validate({ ...dish });
    setErrors(err);
    if (!err.isValid) {
      return;
    }

    inputList.forEach(function (arrayItem, i) {
      if (arrayItem.fromTime == "" || arrayItem.fromTime == null) {
        setFtimeError(true);
      } else {
        setFtimeError(false);
      }
      if (arrayItem.toTime == "" || arrayItem.toTime == null) {
        setTtimeError(true);
      } else {
        setTtimeError(false);
      }
      if ((arrayItem.fromTime != "" || arrayItem.fromTime != null) && (arrayItem.toTime != "" || arrayItem.toTime != null)) {
        newdishtimes.push(arrayItem.fromTime + '-' + arrayItem.toTime);
      }
    });
    if (tagin != "") {
      dish['tagIds'] = tagin.join(",");
    }
    if (newdishtimes != "") {
      dish['times'] = newdishtimes.join(",");
    }
    if (dishtype != "") {
      dish['foodType'] = dishtype;
    }
    if (zipName != "") {
      dish['pinCodes'] = zipName.join(",");
    }
    if (dish['weight'] != "" && dish['metric'] != "") {
      dish['weight'] = dish['weight'] + " " + dish['metric'];
    }

    if (file != "") {
      dish['images'] = file.join(",");
    }
    setLoading(true);
    addsellerdish(dish, (message, isError) => {
      const dishmethod = isError ? 'error' : 'success';
      toast[dishmethod](message);
      setLoading(false);
      if (dishmethod == "success") {
        history.goBack();
        /*setDish({ 
          sellerId:"",
          itemName:"",
          description:"",
          metric:"",
          weight:"",
          price:"",
          maxDishesPerDay:"",
          cuisineId:"",
          categoryId:""
        });*/

      }

      //window.location.reload();
    })

  };
  return (
    <div style={{ width: '100%' }}>
      <div className='mb-3'>
        <Grid container spacing={3}>
          <Grid item xs={10}><h6>Add Dish</h6></Grid>
          <Grid item xs={2}> <Button onClick={() => { history.goBack(); }} size="small" label="Back"></Button></Grid>
        </Grid>
      </div>
      <Card className={classes.root}>
        <CardContent>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Seller type</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={2}>
              <FormControlLabel value="chefs" name="sellertype" control={<Radio />} checked={activeChef} label="Chefs" onChange={handleSellerType} />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel value="restaurants" name="sellertype" control={<Radio />} checked={activeRes} label="Restaurants" onChange={handleSellerType} />
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Select Seller</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              <Autocomplete
                {...SellerdefaultProps}
                variant="outlined"
                name="sellerId"
                onChange={(event, value) => handleChangeSeller("sellerId", value)}
                classes={{ select: classes.inputRoot }}
                disableCloseOnSelect
                renderInput={(params) => (
                  <TextField {...params} label="Select Seller" variant="outlined"
                    error={errors && errors.sellerId && errors.sellerId.isInvalid}
                    helperText={errors && errors.sellerId && errors.sellerId.isInvalid && errors.sellerId.message}
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Dish Name</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              <TextField
                placeholder="Dish Name"
                name="itemName"
                onChange={(e) => handleChange('itemName', e)}
                variant="outlined"
                classes={{ root: classes.input }}
                value={dish.itemName}
                error={errors && errors.itemName && errors.itemName.isInvalid}
                helperText={errors && errors.itemName && errors.itemName.isInvalid && errors.itemName.message}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Description</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              <TextareaAutosize
                rows={5}
                cols={26}
                name="description"
                onChange={(e) => handleChange('description', e)}
                placeholder="Description"
                classes={{ root: classes.input }}
              />
              {<div style={{ color: 'red' }}>{errors && errors.description && errors.description.isInvalid && errors.description.message}</div>}

            </Grid>
          </Grid>

          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Tags</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              {tagslist.map((s, t) => {
                return (
                  <FormControlLabel
                    classes={{ label: classes.checkBoxLabel, root: classes.labelRoot }}
                    control={<GreenCheckbox size="small" />}
                    name="tags"
                    id={s.tagId}
                    label={s.tagName}
                    onChange={(e) => handleChangeTag(e, s.tagId)}
                  />
                );

              })}
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Dish Quantity</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={2}>
              <TextField
                placeholder="Dish Quantity"
                name="weight"
                onChange={(e) => handleChange('weight', e)}
                variant="outlined"
                classes={{ root: classes.input }}
                value={dish.weight}
                error={errors && errors.weight && errors.weight.isInvalid}
                helperText={errors && errors.weight && errors.weight.isInvalid && errors.weight.message}
              />
            </Grid>
            <Grid item xs={2}>
              <Autocomplete
                {...MetricfaultProps}
                id="disable-close-on-select3"
                name="metric"
                variant="outlined"
                disableCloseOnSelect
                onChange={(event, value) => handleChangeMetric("metric", value)}
                renderInput={(params) => (
                  <TextField {...params} label="Select Metric" variant="outlined"
                    error={errors && errors.metric && errors.metric.isInvalid}
                    helperText={errors && errors.metric && errors.metric.isInvalid && errors.metric.message}

                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Price Per Dish</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              <TextField
                placeholder="Dish Price"
                name="price"
                onChange={(e) => handleChange('price', e)}
                variant="outlined"
                classes={{ root: classes.input }}
                value={dish.price}
                error={errors && errors.price && errors.price.isInvalid}
                helperText={errors && errors.price && errors.price.isInvalid && errors.price.message}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Dish Availabilty Timeings</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              {inputList.map((x, i) => {
                return (
                  <Grid container spacing={2}>
                    <Grid item xs={5}>
                      <TimePicker name="fromTime" id={`${i}_from`} use12Hours format="h:mm A" onChange={(time, timeString) => { onChange(time, timeString, i, "fromTime") }} style={{ width: 140 }} />
                      {<div style={{ color: 'red', display: (ftimeError ? 'block' : 'none') }}>Select From Time</div>}
                    </Grid>
                    <Grid item xs={5}>
                      <TimePicker name="toTime" id={`${i}_to`} use12Hours format="h:mm A" onChange={(time, timeString) => { onChange(time, timeString, i, "toTime") }} style={{ width: 140 }} />
                      {<div style={{ color: 'red', display: (ttimeError ? 'block' : 'none') }} >Select To Time</div>}
                    </Grid>

                    <Grid item xs={2}>
                      <div>
                        <Grid container spacing={2}>
                          <Grid item xs={5}>
                            {inputList.length !== 1 && <Button
                              label={'Remove'} color="primary"
                              onClick={() => handleRemoveClick(i)} />}
                            {inputList.length - 1 === i && <Button label={'Add'} className="mt-2" color="primary" onClick={handleAddClick} />}
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                );
              })}

            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Delivery activate area zip Codes</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              <FormControl className={classes.formControl}>
                <InputLabel id="demo-multiple-checkbox-label" style={{ marginLeft: "15px" }}>Select ZipCodes</InputLabel>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  name="zipName"
                  displayEmpty
                  value={zipName}
                  classes={{ select: classes.inputRoot }}
                  onChange={handleChangeZipcode}
                  input={<OutlinedInput label="Zipcodes" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}

                >

                  {zipcodeslist.filter((item) => item.status == 1).map((s) => (
                    <MenuItem key={s.id} value={s.pinCode}>
                      <Checkbox checked={zipName.indexOf(s.pinCode) > -1} />
                      <ListItemText primary={s.pinCode} />
                    </MenuItem>

                  ))}

                </Select>
                {<div style={{ color: 'red', display: (pinError ? 'block' : 'none') }}>Select Zip Code</div>}

              </FormControl>


            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>No.of prepared dished per day</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              <TextField
                placeholder="No.of Dishes"
                name="maxDishesPerDay"
                onChange={(e) => handleChange('maxDishesPerDay', e)}
                variant="outlined"
                classes={{ root: classes.input }}
                value={dish.maxDishesPerDay}
                error={errors && errors.maxDishesPerDay && errors.maxDishesPerDay.isInvalid}
                helperText={errors && errors.maxDishesPerDay && errors.maxDishesPerDay.isInvalid && errors.maxDishesPerDay.message}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Upload dish photos</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              <input style={{ width: "103px", background: "#f58634", border: "none" }} type="file" className="form-control" name='images' onChange={uploadMultipleFiles} multiple
              />
              {/* <div style={{color:'red'}}>{errors && errors.images && errors.images.isInvalid && errors.images.message}</div> */}

              {file != "" &&
                <Grid container spacing={2} className='mt-2'>
                  {(file || []).map(url => (
                    <Grid item xs={3} className='mr-2'>
                      <span><img src={url} alt="..." style={{ width: '100px' }} /><span><img src={Icons.closebtn} alt="close" style={{ width: "20px", top: "-39px", left: "80px" }} onClick={() => { removeImage(url) }} /></span></span>
                    </Grid>
                  ))}
                </Grid>
              }
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Dish type</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={2}>
              <FormControlLabel value="Veg" name="dishtype" checked={activeVeg} control={<Radio />} label="Veg" onChange={handleDishType} />
            </Grid>
            <Grid item xs={2}>
              <FormControlLabel value="Non Veg" name="dishtype" checked={activeNonVeg} control={<Radio />} label="Non Veg" onChange={handleDishType} />
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Select Cuisine</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>

              <Autocomplete
                {...CuidefaultProps}
                id="disable-close-on-select3"
                name="cuisineId"
                variant="outlined"
                disableCloseOnSelect
                onChange={(event, value) => handleChangeCui("cuisineId", value)}
                renderInput={(params) => (
                  <TextField {...params} label="Select Cuisine" variant="outlined"
                    error={errors && errors.cuisineId && errors.cuisineId.isInvalid}
                    helperText={errors && errors.cuisineId && errors.cuisineId.isInvalid && errors.cuisineId.message}

                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} className='mt-2'>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}><h5>Select Category</h5></Grid>
            <Grid item xs={1}><h5>:</h5></Grid>
            <Grid item xs={4}>
              <Autocomplete
                {...CatedefaultProps}
                id="disable-close-on-select2"
                name="categoryId"
                variant="outlined"
                disableCloseOnSelect
                onChange={(event, value) => handleChangeCate("categoryId", value)}
                renderInput={(params) => (
                  <TextField {...params} label="Select Category" variant="outlined"
                    error={errors && errors.categoryId && errors.categoryId.isInvalid}
                    helperText={errors && errors.categoryId && errors.categoryId.isInvalid && errors.categoryId.message}

                  />
                )}
              />
            </Grid>
          </Grid>
          <div className='mb-3'>
            <Grid container spacing={3}>
              <Grid item xs={5}></Grid>
              <Grid item xs={2}> <Button size="small" label="Add Dish" onClick={addDish}></Button></Grid>
              <Grid item xs={5}></Grid>
            </Grid>
          </div>
        </CardContent>
      </Card>

    </div>

  )

};

export default AddItems;
